// extracted by mini-css-extract-plugin
export var searchHeader = "_6k-0";
export var searchHeaderDark = "_6k-1";